module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), (_vm.isIcon) ? _c('div', [(_vm.m_note_id > 0) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn-action",
    attrs: {
      "size": "sm",
      "variant": "primary",
      "title": 'Edit ' + (_vm.m_creditDebitNoteType == 2 ? 'Debit' : 'Credit') + ' Note'
    },
    on: {
      "click": function($event) {
        _vm.getNoteDetails(_vm.m_note_id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil text-white"
  })]) : _vm._e()], 1) : (_vm.m_note_id > 0) ? _c('b-button', {
    staticClass: "mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "xs",
      "variant": _vm.m_creditDebitNoteType == 2 ? 'outline-success' : 'outline-danger'
    },
    on: {
      "click": function($event) {
        _vm.getNoteDetails(_vm.m_note_id)
      }
    }
  }, [_vm._v(_vm._s(_vm.m_creditDebitNoteType == 2 ? "Debit " : "Credit ") + _vm._s(_vm.m_noteSeries) + " Note")]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "common-note-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.m_title
    }
  }, [_c('b-row', [_c('b-col', {
    staticStyle: {
      "text-align": "end"
    },
    attrs: {
      "cols": "11"
    }
  }, [(_vm.$sessionsStorage.get('designation') == 'Admin' && _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('b-form-checkbox', {
    staticClass: "mr-3",
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle"
    },
    model: {
      value: (_vm.isValidationRequired),
      callback: function($$v) {
        _vm.isValidationRequired = $$v
      },
      expression: "isValidationRequired"
    }
  }, [_vm._v("\n          Enable Validation\n        ")]) : _vm._e(), _vm._v(" "), (_vm.pdf_link != '' && _vm.m_approvalStatus == '1') ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.PrintNote(_vm.JOB_NO, _vm.pdf_link)
      }
    }
  }, [_vm._v("PDF")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.addContent
    }
  }, [_vm._v("\n          Add Particulars\n          "), _c('i', {
    staticClass: "fa fa-plus-circle ml-1"
  })])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12 text-center"
    }
  }, [(_vm.noteModal.creditcount >= 1 && _vm.noteModal.creditDebitNoteType == '1') ? _c('span', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Credit Note No. :")]), _vm._v("\n          " + _vm._s(_vm.noteModal.creditnoteSeriesDetailsCount) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.noteModal.debitcount >= 1 && _vm.noteModal.creditDebitNoteType == '2') ? _c('span', [_c('span', {
    staticClass: "error"
  }, [_vm._v("DEBIT Note No. :")]), _vm._v("\n          " + _vm._s(_vm.noteModal.debitnoteSeriesDetailsCount) + "\n        ")]) : _vm._e()])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Type "), (_vm.isValidationRequired) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.agentTypeList,
      "option-value": "TypeVal",
      "option-text": "TypeTxt",
      "placeholder": "Select Type"
    },
    on: {
      "input": function($event) {
        _vm.getAgentConsigneeList(_vm.noteModal.agentType)
      }
    },
    model: {
      value: (_vm.noteModal.agentType),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "agentType", $$v)
      },
      expression: "noteModal.agentType"
    }
  }), _vm._v(" "), (!_vm.noteModal.agentType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.agentType))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          To\n          "), (_vm.isValidationRequired) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getAllAgentColoaderList.length > 0 ?
        _vm.getAllAgentColoaderList :
        this.$store.getters['common/getAllAgentColoaderList'],
      "option-value": "agentName",
      "option-text": "agentName",
      "placeholder": _vm.noteModal.agentType == 'Consignee' ?
        'Select Consignee' :
        'Select Agent/Coloader'
    },
    on: {
      "input": _vm.getConsigneeAgentDetails
    },
    model: {
      value: (_vm.noteModal.AgentColoader),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "AgentColoader", $$v)
      },
      expression: "noteModal.AgentColoader"
    }
  }), _vm._v(" "), (!_vm.noteModal.AgentColoader) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.AgentColoader))]) : _vm._e()], 1), _vm._v(" "), (_vm.noteModal.agentType == 'Consignee') ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Consignee Address"
    }
  }, [_vm._v("\n          Consignee Address\n          "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Consignee Address"
    },
    model: {
      value: (_vm.noteModal.agentconsigneeAddress),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "agentconsigneeAddress", $$v)
      },
      expression: "noteModal.agentconsigneeAddress"
    }
  }), _vm._v(" "), (!_vm.noteModal.agentconsigneeAddress) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.agentconsigneeAddress))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.noteModal.agentType == 'Agent') ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Agent Country"
    }
  }, [_vm._v("\n          Agent Country\n          "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Agent Country"
    },
    model: {
      value: (_vm.noteModal.agent_country),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "agent_country", $$v)
      },
      expression: "noteModal.agent_country"
    }
  }), _vm._v(" "), (!_vm.noteModal.agent_country) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.agent_country))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Vessel/Voy"
    }
  }, [_vm._v("\n          Vessel/Voy\n          "), (_vm.isValidationRequired) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Vessel Voy"
    },
    model: {
      value: (_vm.noteModal.vesselVoy),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "vesselVoy", $$v)
      },
      expression: "noteModal.vesselVoy"
    }
  }), _vm._v(" "), (!_vm.noteModal.vesselVoy) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.vesselVoy))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "HBL/AWB"
    }
  }, [_vm._v("\n          HBL/AWB\n          "), (_vm.isValidationRequired) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter HBL/AWB"
    },
    model: {
      value: (_vm.noteModal.house_bl_no),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "house_bl_no", $$v)
      },
      expression: "noteModal.house_bl_no"
    }
  }), _vm._v(" "), (!_vm.noteModal.house_bl_no) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.house_bl_no))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "MBL/MAWB"
    }
  }, [_vm._v("\n          MBL/MAWB\n          "), (_vm.isValidationRequired) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter MBL/MAWB"
    },
    model: {
      value: (_vm.noteModal.master_bl_no),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "master_bl_no", $$v)
      },
      expression: "noteModal.master_bl_no"
    }
  }), _vm._v(" "), (!_vm.noteModal.master_bl_no) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.master_bl_no))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "SHIPPER"
    }
  }, [_vm._v("\n          SHIPPER\n          "), (_vm.isValidationRequired) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter SHIPPER"
    },
    model: {
      value: (_vm.noteModal.clientName),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "clientName", $$v)
      },
      expression: "noteModal.clientName"
    }
  }), _vm._v(" "), (!_vm.noteModal.clientName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.clientName))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "CONSIGNEE"
    }
  }, [_vm._v("\n          CONSIGNEE\n          "), (_vm.isValidationRequired) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter CONSIGNEE"
    },
    model: {
      value: (_vm.noteModal.consignee),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "consignee", $$v)
      },
      expression: "noteModal.consignee"
    }
  }), _vm._v(" "), (!_vm.noteModal.consignee) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.consignee))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Destination"
    }
  }, [_vm._v("\n          Destination\n          "), (_vm.isValidationRequired) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Destination"
    },
    model: {
      value: (_vm.noteModal.FPOD),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "FPOD", $$v)
      },
      expression: "noteModal.FPOD"
    }
  }), _vm._v(" "), (!_vm.noteModal.FPOD) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.FPOD))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Container No"
    }
  }, [_vm._v("\n          Container No.\n          "), (_vm.isValidationRequired) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Container No"
    },
    model: {
      value: (_vm.noteModal.containerNoArryNote),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "containerNoArryNote", $$v)
      },
      expression: "noteModal.containerNoArryNote"
    }
  }), _vm._v(" "), (!_vm.noteModal.containerNoArryNote) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.containerNoArryNote))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Container Type"
    }
  }, [_vm._v("\n          Container Type\n          "), (_vm.isValidationRequired) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Container Type."
    },
    model: {
      value: (_vm.noteModal.containersTypes),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "containersTypes", $$v)
      },
      expression: "noteModal.containersTypes"
    }
  }), _vm._v(" "), (!_vm.noteModal.containersTypes) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.containersTypes))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "SHIPPER INV."
    }
  }, [_vm._v("\n          SHIPPER INV.\n          "), (_vm.isValidationRequired) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter SHIPPER INV. Details"
    },
    model: {
      value: (_vm.noteModal.ShipperInvDet),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "ShipperInvDet", $$v)
      },
      expression: "noteModal.ShipperInvDet"
    }
  }), _vm._v(" "), (!_vm.noteModal.ShipperInvDet) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.ShipperInvDet))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "Booking No"
    }
  }, [_vm._v("\n          Booking No\n          "), (_vm.isValidationRequired) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Booking No"
    },
    model: {
      value: (_vm.noteModal.validBookingNo),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "validBookingNo", $$v)
      },
      expression: "noteModal.validBookingNo"
    }
  }), _vm._v(" "), (!_vm.noteModal.validBookingNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.validBookingNo))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "SOB"
    }
  }, [_vm._v("\n          SOB\n          "), (_vm.isValidationRequired) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "SOB",
      "minute-step": 1,
      "name": "SOB"
    },
    model: {
      value: (_vm.noteModal.SOB),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "SOB", $$v)
      },
      expression: "noteModal.SOB"
    }
  }), _vm._v(" "), (!_vm.noteModal.SOB) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.SOB))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "ETADest"
    }
  }, [_vm._v("\n          ETA Dest\n          "), (_vm.isValidationRequired) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "ETADest",
      "minute-step": 1,
      "name": "ETADest"
    },
    model: {
      value: (_vm.noteModal.ETADest),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "ETADest", $$v)
      },
      expression: "noteModal.ETADest"
    }
  }), _vm._v(" "), (!_vm.noteModal.ETADest) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.ETADest))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "Remarks"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "3"
    },
    model: {
      value: (_vm.noteModal.remarks),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "remarks", $$v)
      },
      expression: "noteModal.remarks"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered mt-2"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [(_vm.noteParticulars.length > 0) ? _c('tr', [_c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Particulars")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("QTY")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Final")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Selected Cont")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Currency")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Actions")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.noteParticulars), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "placeholder": "Enter Particular"
      },
      model: {
        value: (item.parti),
        callback: function($$v) {
          _vm.$set(item, "parti", $$v)
        },
        expression: "item.parti"
      }
    }), _vm._v(" "), (item.parti_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.parti_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "type": "number",
        "min": "0",
        "placeholder": "QTY"
      },
      on: {
        "keyup": _vm.TotalAMT
      },
      model: {
        value: (item.qty),
        callback: function($$v) {
          _vm.$set(item, "qty", $$v)
        },
        expression: "item.qty"
      }
    }), _vm._v(" "), (item.qty_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.qty_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "placeholder": "Enter Amount"
      },
      on: {
        "keyup": _vm.TotalAMT
      },
      model: {
        value: (item.amt),
        callback: function($$v) {
          _vm.$set(item, "amt", $$v)
        },
        expression: "item.amt"
      }
    }), _vm._v(" "), (item.amt_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.amt_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(item.final_amt || 0))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(item.container_selected || "-"))])]), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.$store.getters['common/getAllCurrencyList'],
        "option-value": "currency_id",
        "option-text": "currencyCode",
        "placeholder": "Select Currency"
      },
      model: {
        value: (item.currency),
        callback: function($$v) {
          _vm.$set(item, "currency", $$v)
        },
        expression: "item.currency"
      }
    }), _vm._v(" "), (item.currency_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.currency_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(index > 0) ? _c('b-button', {
      attrs: {
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeParti(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()], 1)])
  }), _vm._v(" "), (_vm.TotAMT != 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.TotAMT))])])]) : _vm._e()], 2)])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [(_vm.noteParticulars.length > 0 && _vm.noteModal.AgentColoader) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "disabled": _vm.IsCDNotedisabled,
      "variant": "success"
    },
    on: {
      "click": _vm.submitNote
    }
  }, [(_vm.IsCDNotedisabled) ? _c('span', [_c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }), _vm._v("Updating...\n          ")], 1) : _c('span', [_vm._v("Update")])]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideNoteModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ba25bd3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/editCRDRNote.vue
// module id = 2768
// module chunks = 0